// See docs/loadable-components.md for details regarding **.imports-X.** file extension & duplicate file structure.
import React from 'react';
import loadable from '@loadable/component';
import Loading from '../../Loading';
import retry from '../../../utils/retry';

const MfaFlow = loadable(() => retry(() => import('./MfaFlow')), {
  fallback: <Loading size="lg" />,
});

export default MfaFlow;
